import triggerTracking from '@blueprint/tracking';
import { TRACKING_EVENT, TRACKING_CATEGORY } from 'listing-details/constants';
import { ListingSharingCategory } from './ListingSharing.types';

export const trackFacebookShare = (
    listingId: number,
    category?: ListingSharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'facebook'
    });
};

export const trackTwitterShare = (
    listingId: number,
    category?: ListingSharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'twitter'
    });
};

export const trackClipboardShare = (
    listingId: number,
    category?: ListingSharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'copy link'
    });
};

export const trackWhatsAppShare = (
    listingId: number,
    category?: ListingSharingCategory
) => {
    triggerTracking({
        event: TRACKING_EVENT,
        eventCategory: category || TRACKING_CATEGORY,
        eventValue: listingId,
        eventAction: 'click to share',
        eventLabel: 'whatsapp'
    });
};
